import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { UploadBtn } from '../../styles/Popup/Dropzone.styled';
import { DoneIcon } from '../../../public/icons';
import styles from '../../styles/Popup/Popup.module.css';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ClearIcon from '@mui/icons-material/Clear';
import { isiOS } from '../../helpers/isiOS';


interface DropzoneWithLabelProps {
  onFileDrop: (files: File[]) => void;
  uploadKey: object;
  isMobile?: boolean;
  checkExtension: boolean;
  setCheckExtension: React.Dispatch<React.SetStateAction<boolean>>;
}

const passExtension = ['.jks', '.dat', '.zs2', '.sk', '.pk8', '.pfx'];

const DropzoneWithLabel: React.FC<DropzoneWithLabelProps> = ({
        setCheckExtension,
        checkExtension,
        onFileDrop,
        uploadKey,
        isMobile,
      }) => {

  const [drag, setDrag] = useState(false);

  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach(({ path }) => {
        const extension = path.split('.').pop().toLowerCase();
        if (!passExtension.includes(`.${extension}`)) {
          setCheckExtension(false);
          // alert("Файл має неприпустиме розширення");
          return;
        } else {
          setCheckExtension(true);
        }
      });
      onFileDrop(acceptedFiles);

      if (onFileDrop) {
        if (acceptedFiles?.length > 1) {
          alert('Оберіть тільки один файл');
          return;
        }
      }
    },
    [onFileDrop],
  );


  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept:
      !isiOS() && !drag ?
        { 'application/octet-stream': ['.jks', '.dat', '.zs2', '.sk', '.pk8', '.pfx'] }
        : {},
  });

  useEffect(() => {
    isDragActive ? setDrag(true) : setDrag(false);
  }, [isDragActive]);
  console.log(isMobile);

  return (
    <UploadBtn {...getRootProps()} $isDragActive={uploadKey} $checkExtension={checkExtension}>
      <input {...getInputProps()} />
      {uploadKey ? (
        <>
          {checkExtension ? <DoneIcon
            /> : <ClearIcon
            sx={{
              width: '30px',
              height: '30px',
              padding: '3px',
              borderRadius: '50%',
              marginBottom: '8px',
              backgroundColor: 'var(--red)',
              color: 'var(--white)',
            }}
          />}

          <div className={styles.uploadKeyName}>{uploadKey?.name}</div>

          <u>Замінити</u>
          {/*<input*/}
          {/*  type="file"*/}
          {/*  name="file"*/}
          {/*  hidden*/}
          {/*  onChange={onFileDrop}*/}
          {/*  accept=".jks,.dat,.zs2,.sk,.pk8,.pfx"*/}
          {/*/>*/}

        </>
      ) : (
        <>
          <div className={styles.plusIcon}>
            <AddCircleIcon
              sx={{
                height: '40px',
                width: '40px',
                color: '#E4ECFF',
              }}
            />
          </div>
          <h4>
            {/* {!isMobile ? (
              'Завантажити КЕП'
            ) : ( */}
              <>
                Перетягніть файловий КЕП або
                <br />
                завантажте його зі свого носія
              </>
            {/* )} */}
            <br />
            <span>(формати .dat (key-6.dat), .jks, .zs2, .sk, .pk8, .pfx)</span>
          </h4> 
        </>
      )}
    </UploadBtn>
  );
};

export default DropzoneWithLabel;

interface DropzoneUploadDocsProps extends Omit<DropzoneWithLabelProps, 'uploadKey'> {
  selectedFiles?: File[];
  onRemoveFile: (index: number) => void;
  disabled?: boolean;
  failure?: boolean;
}

const ALLOWED_EXTENSIONS = ['.pdf'];

export const DropzoneUploadDocs: React.FC<DropzoneUploadDocsProps> = ({
  setCheckExtension,
  checkExtension,
  onFileDrop,
  onRemoveFile,
  selectedFiles = [],
  disabled = false,
  failure = false
}) => {
  const [error, setError] = useState<string | null>(null);
  const [isErrorVisible, setIsErrorVisible] = useState(false);

  const onDrop = useCallback((acceptedFiles: File[], fileRejections: FileRejection[]) => {
    setError(null);
    if (fileRejections.length > 0) {
      const isExtensionError = fileRejections.some(rejection => 
        rejection.errors.some(e => e.code === 'file-invalid-type')
      );
      if (isExtensionError) {
        showErrorMessage("Невірний формат файлу (дозволено лише .pdf)");
        setCheckExtension(false);
      }
    }
    const finalFiles = acceptedFiles.filter(newFile => 
      !selectedFiles.some(existing => 
        existing.name === newFile.name && existing.size === newFile.size
      )
    );
    if (finalFiles.length < acceptedFiles.length) {
      showErrorMessage("Деякі файли вже додані");
    }
    if (finalFiles.length > 0) {
      setCheckExtension(true);
      onFileDrop(finalFiles);
    }
  }, [onFileDrop, selectedFiles, setCheckExtension]);

    useEffect(() => {
        if (failure) {
          showErrorMessage("Помилка завантаження");
        }
      }, [failure]);
  

  const showErrorMessage = (message: string) => {
    setError(message);
    setIsErrorVisible(true);
    
    setTimeout(() => {
      setIsErrorVisible(false);
      setTimeout(() => setError(null), 300);
    }, 3000);
  };


  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: !isiOS() ? { 'application/octet-stream': ALLOWED_EXTENSIONS } : { 'application/pdf': ALLOWED_EXTENSIONS },
    multiple: true,
    disabled: disabled,
  });

  const hasFiles = selectedFiles.length > 0;

  return (
    <UploadBtn 
      {...getRootProps()} 
      $isDragActive={isDragActive} 
      $checkExtension={checkExtension}
      $hasFiles={hasFiles}
      $disabled={disabled}
      $failure={failure}
    >
      <input {...getInputProps()} />
      {hasFiles ? (
        <>
          <div className={styles.filesContainer} onClick={(e) => e.stopPropagation()}>
            <ul className={styles.fileList}>
              {selectedFiles.map((file, index) => (
                <li key={`${file.name}-${index}`} className={styles.fileItem}>
                  <div className={styles.fileInfo}>
                    <DoneIcon size={20}/>
                    <span className={styles.fileName}>{file.name}</span>
                  </div>
                  <button 
                    type="button" 
                    className={styles.removeBtn}
                    onClick={() => onRemoveFile(index)}
                  >
                    <ClearIcon sx={{ fontSize: '18px' }} />
                  </button>
                </li>
              ))}
            </ul>
            
          </div>
          <div className={styles.statusFooter}>
            {error ? (
              <div className={`${styles.errorWrapper} ${isErrorVisible ? styles.visible : styles.hidden}`}>
                    <ClearIcon sx={{ color: 'var(--red)', fontSize: '20px' }} />
                    <span className={styles.errorText}>{error}</span>
                </div>
              ) : (
                <>
                  <div className={styles.plusIcon}>
                    <AddCircleIcon sx={{ height: '40px', width: '40px', color: '#E4ECFF' }} />
                  </div>
                  <div className={styles.replaceLink}>Додати ще</div>
                </>
            )}
          </div>
        </>
      ) : (
        <>
          {error ? (
            <div className={`${styles.errorWrapper} ${isErrorVisible ? styles.visible : styles.hidden}`}>
                <ClearIcon sx={{ color: 'var(--red)', fontSize: '20px' }} />
                <span className={styles.errorText}>{error}</span>
            </div>
          ) : (
            <>
              <div className={styles.plusIcon}>
                <AddCircleIcon
                  sx={{
                    height: '40px',
                    width: '40px',
                    color: '#E4ECFF',
                  }}
                />
              </div>
              <h4 style={{textAlign: "center"}}>
                {isDragActive ? (
                  <>
                        Відпустіть файли
                        <br />
                        <br />
                      </>
                  ) : (
                      <>
                        Перетягніть файли або
                        <br />
                        завантажте його зі свого носія
                      </>
                )}
                <br />
                <span>(формат .pdf)</span>
              </h4> 
            </>
          )}
        </>
      )}
    </UploadBtn>
  );
};

